export default "__VITE_ASSET__KMmsaZGe__"